// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    organizationId: z.string().min(1).max(21),
    departmentId: z.string().min(1).max(21),
    userId: z.string().min(1).max(128),
});
const guard = z.object({
    tenantId: z.string().max(21),
    organizationId: z.string().min(1).max(21),
    departmentId: z.string().min(1).max(21),
    userId: z.string().min(1).max(128),
});
export const OrganizationDirectoryAssignments = Object.freeze({
    table: 'organization_directory_assignments',
    tableSingular: 'organization_directory_assignment',
    fields: {
        tenantId: 'tenant_id',
        organizationId: 'organization_id',
        departmentId: 'department_id',
        userId: 'user_id',
    },
    fieldKeys: [
        'tenantId',
        'organizationId',
        'departmentId',
        'userId',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
